export default "__VITE_ASSET__ChSzPB8Y__"